import RMMultiSelectSearchDropdown from 'components/customComponents/CommonComponents/RMMultiSelectSearchDropdown';
import React, { useEffect } from 'react';
import { useAllIngredientStocksInExperiment, useAllPlates } from 'redux/hooks/experiment';
import { computeIngredientFilterWells } from '../filterComputations';
import { useFindDropContext } from '../FindDropContext';

const IngredientsFilter = () => {
  const {
    selectedIngredients,
    setSelectedIngredients,
    ingredientFilterLogic,
    setIngredientFilterLogic,
    setHighlightedIngredientWells,
  } = useFindDropContext();
  const allIngredients = useAllIngredientStocksInExperiment();
  const plates = useAllPlates();

  useEffect(() => {
    setHighlightedIngredientWells(
      computeIngredientFilterWells(plates, selectedIngredients, ingredientFilterLogic),
    );
  }, [selectedIngredients, ingredientFilterLogic, plates, setHighlightedIngredientWells]);

  return (
    <div className="flex flex-row px-[10px] gap-x-1 my-2">
      <div className="w-[30%]">Ingredient Name</div>
      <RMMultiSelectSearchDropdown
        id="ingredient-filter"
        options={allIngredients}
        selectedIds={selectedIngredients}
        onSelectionChange={setSelectedIngredients}
        filterLogic={ingredientFilterLogic}
        onFilterLogicChange={setIngredientFilterLogic}
        getOptionId={(x) => x}
        getOptionLabel={(x) => x}
        className="w-[70%]"
      />
    </div>
  );
};

export default IngredientsFilter;
